export const tag = 'm050c040mainnavigationpw';
export const load = async () => {
    const { M050C040MainnavigationPwComponent } = await import('./m050-c040-mainnavigation-pw.component');
    return {
        component: M050C040MainnavigationPwComponent,
    };
};
